import { Facebook, Instagram, Mail } from '@mui/icons-material';
import {
  Box,
  CardMedia,
  Container,
  Divider,
  Grid,
  Link as MuiLink,
  Stack,
  Typography,
} from '@mui/material';

const Footer = () => {
  return (
    <Box component="footer" sx={{ bgcolor: '#2E7D32', color: '#fff', pt: 6, pb: 2 }}>
      <Container maxWidth="lg">
        {/* ÉTAGE 1 — bandeau principal */}
        <Grid container spacing={6} alignItems="flex-start">
          {/* Colonne 1 — Branding + tagline (logos en LIGNE) */}
          <Grid item xs={12} md={5} sx={{ minWidth: 0 }}>
            <Stack direction="row" alignItems="center" spacing={2} sx={{ minWidth: 0, mb: 2 }}>
              <CardMedia
                component="img"
                src="/images/logos/icon_white.png"
                alt="Icône Indice Fossile"
                sx={{ height: { xs: 36, sm: 42, md: 48 }, width: 'auto', objectFit: 'contain', flexShrink: 0 }}
              />
              <CardMedia
                component="img"
                src="/images/logos/text_white.png"
                alt="Logotype Indice Fossile"
                sx={{
                  height: { xs: 36, sm: 42, md: 48 },
                  width: 'auto',
                  objectFit: 'contain',
                  flexShrink: 1,
                  maxWidth: '100%',
                }}
              />
            </Stack>

            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
              Nous rendons l’information environnementale lisible, vérifiable et actionnable.
              Comparez l’empreinte de vos achats, faites des choix éclairés.
            </Typography>
          </Grid>

          {/* Colonne 2 — Navigation utile */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1.5 }}>Découvrir</Typography>
            <Stack spacing={1}>
              <MuiLink href="/actualites" sx={{ color: '#e8f5e9', textDecoration: 'none' }}>Blog & actualités</MuiLink>
              <MuiLink href="/mentions-legales" sx={{ color: '#e8f5e9', textDecoration: 'none' }}>Mentions légales</MuiLink>
              <MuiLink href="/condition-d-utilisation" sx={{ color: '#e8f5e9', textDecoration: 'none' }}>
                Conditions d’utilisation
              </MuiLink>
            </Stack>
          </Grid>

          {/* Colonne 3 — Dons / Adhésions (call-to-action) */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1.5 }}>Soutenir l’association</Typography>
            <Stack spacing={1}>
              <MuiLink
                target="_blank"
                href="https://www.payasso.fr/indice-fossile/adhesions"
                sx={{ color: '#fff', textDecoration: 'none', fontWeight: 600 }}
              >
                Devenir adhérent
              </MuiLink>
              <MuiLink
                target="_blank"
                href="https://www.payasso.fr/indice-fossile/dons"
                sx={{ color: '#e8f5e9', textDecoration: 'none' }}
              >
                Faire un don
              </MuiLink>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.25)' }} />

        {/* ÉTAGE 2 — bandeau bas */}
        <Grid container spacing={2} alignItems="center">
          {/* Contact */}
          <Grid item xs={12} md={6}>
            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ flexWrap: 'wrap' }}>
              <Typography variant="body2" sx={{ fontWeight: 700 }}>Contact</Typography>
              <Mail fontSize="small" />
              <MuiLink
                href="mailto:contact@indicefossile.fr"
                sx={{ color: '#e0f2f1', textDecoration: 'none' }}
              >
                contact@indicefossile.fr
              </MuiLink>
            </Stack>
          </Grid>

          {/* Réseaux */}
          <Grid item xs={12} md={3}>
            <Stack direction="row" spacing={2}>
              <MuiLink
                href="https://www.facebook.com/profile.php?id=61575120808131"
                target="_blank"
                aria-label="Facebook"
                sx={{ color: '#e0f2f1' }}
              >
                <Facebook />
              </MuiLink>
              <MuiLink
                href="https://www.instagram.com/indicefossile/"
                target="_blank"
                aria-label="Instagram"
                sx={{ color: '#e0f2f1' }}
              >
                <Instagram />
              </MuiLink>
            </Stack>
          </Grid>

          {/* © / baseline droite */}
          <Grid item xs={12} md={3} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.8)' }}>
              © {new Date().getFullYear()} Indice Fossile — Tous droits réservés
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;